import { ImportMap } from './types.js';

export const importMap: ImportMap = {
  imports: {
    'https://cdn.jsdelivr.net/npm/mobx-persist-store@1.1.5/lib/esm5/PersistStore':
      'https://cdn.jsdelivr.net/npm/mobx-persist-store@1.1.5/lib/esm5/PersistStore.js',
    'https://cdn.jsdelivr.net/npm/mobx-persist-store@1.1.5/lib/esm5/PersistStoreMap':
      'https://cdn.jsdelivr.net/npm/mobx-persist-store@1.1.5/lib/esm5/PersistStoreMap.js',
    'https://cdn.jsdelivr.net/npm/mobx-persist-store@1.1.5/lib/esm5/StorageAdapter':
      'https://cdn.jsdelivr.net/npm/mobx-persist-store@1.1.5/lib/esm5/StorageAdapter.js',
    'https://cdn.jsdelivr.net/npm/mobx-persist-store@1.1.5/lib/esm5/clearPersistedStore':
      'https://cdn.jsdelivr.net/npm/mobx-persist-store@1.1.5/lib/esm5/clearPersistedStore.js',
    'https://cdn.jsdelivr.net/npm/mobx-persist-store@1.1.5/lib/esm5/configurePersistable':
      'https://cdn.jsdelivr.net/npm/mobx-persist-store@1.1.5/lib/esm5/configurePersistable.js',
    'https://cdn.jsdelivr.net/npm/mobx-persist-store@1.1.5/lib/esm5/getPersistedStore':
      'https://cdn.jsdelivr.net/npm/mobx-persist-store@1.1.5/lib/esm5/getPersistedStore.js',
    'https://cdn.jsdelivr.net/npm/mobx-persist-store@1.1.5/lib/esm5/hydrateStore':
      'https://cdn.jsdelivr.net/npm/mobx-persist-store@1.1.5/lib/esm5/hydrateStore.js',
    'https://cdn.jsdelivr.net/npm/mobx-persist-store@1.1.5/lib/esm5/isHydrated':
      'https://cdn.jsdelivr.net/npm/mobx-persist-store@1.1.5/lib/esm5/isHydrated.js',
    'https://cdn.jsdelivr.net/npm/mobx-persist-store@1.1.5/lib/esm5/isPersisting':
      'https://cdn.jsdelivr.net/npm/mobx-persist-store@1.1.5/lib/esm5/isPersisting.js',
    'https://cdn.jsdelivr.net/npm/mobx-persist-store@1.1.5/lib/esm5/makePersistable':
      'https://cdn.jsdelivr.net/npm/mobx-persist-store@1.1.5/lib/esm5/makePersistable.js',
    'https://cdn.jsdelivr.net/npm/mobx-persist-store@1.1.5/lib/esm5/pausePersisting':
      'https://cdn.jsdelivr.net/npm/mobx-persist-store@1.1.5/lib/esm5/pausePersisting.js',
    'https://cdn.jsdelivr.net/npm/mobx-persist-store@1.1.5/lib/esm5/serializableProperty':
      'https://cdn.jsdelivr.net/npm/mobx-persist-store@1.1.5/lib/esm5/serializableProperty.js',
    'https://cdn.jsdelivr.net/npm/mobx-persist-store@1.1.5/lib/esm5/startPersisting':
      'https://cdn.jsdelivr.net/npm/mobx-persist-store@1.1.5/lib/esm5/startPersisting.js',
    'https://cdn.jsdelivr.net/npm/mobx-persist-store@1.1.5/lib/esm5/stopPersisting':
      'https://cdn.jsdelivr.net/npm/mobx-persist-store@1.1.5/lib/esm5/stopPersisting.js',
    'https://cdn.jsdelivr.net/npm/mobx-persist-store@1.1.5/lib/esm5/types':
      'https://cdn.jsdelivr.net/npm/mobx-persist-store@1.1.5/lib/esm5/types.js',
    'https://cdn.jsdelivr.net/npm/mobx-persist-store@1.1.5/lib/esm5/utils':
      'https://cdn.jsdelivr.net/npm/mobx-persist-store@1.1.5/lib/esm5/utils.js',
    'workbox-window': 'https://cdn.jsdelivr.net/npm/workbox-window@7.1.0/+esm',
    'moment-timezone':
      'https://cdn.jsdelivr.net/npm/moment-timezone@0.5.45/+esm',
    graphql: 'https://cdn.jsdelivr.net/npm/graphql@16.9.0/+esm',
    'graphql-request':
      'https://cdn.jsdelivr.net/npm/graphql-request@7.1.0/+esm',
    '@graphql-codegen/cli':
      'https://cdn.jsdelivr.net/npm/@graphql-codegen/cli@5.0.2',
    '@graphql-codegen/client-preset':
      'https://cdn.jsdelivr.net/npm/@graphql-codegen/client-preset@4.3.3/+esm',
    '@graphql-codegen/introspection':
      'https://cdn.jsdelivr.net/npm/@graphql-codegen/introspection@4.0.3/+esm',
    'lodash.debounce':
      'https://cdn.jsdelivr.net/npm/lodash.debounce@4.0.8/+esm',
    'crypto-js': 'https://cdn.jsdelivr.net/npm/crypto-js@4.2.0/+esm',
    'jwt-decode': 'https://cdn.jsdelivr.net/npm/jwt-decode@4.0.0/+esm',
    'oidc-client-ts': 'https://cdn.jsdelivr.net/npm/oidc-client-ts@3.0.1/+esm',
    'cross-fetch': 'https://cdn.jsdelivr.net/npm/cross-fetch@4.0.0/+esm',
    react: 'https://cdn.jsdelivr.net/npm/react@18.3.1/+esm',
    'react-dom': 'https://cdn.jsdelivr.net/npm/react-dom@18.3.1/+esm',
    'lit-i18n': 'https://cdn.jsdelivr.net/npm/lit-i18n@4.1.0/index.js',
    '@open-wc/lit-helpers':
      'https://cdn.jsdelivr.net/npm/@open-wc/lit-helpers@0.7.0/index.js',
    i18next:
      'https://cdn.jsdelivr.net/npm/i18next@23.15.0/dist/esm/i18next.bundled.js',
    '@microsoft/applicationinsights-web':
      'https://cdn.jsdelivr.net/npm/@microsoft/applicationinsights-web@3.3.2/+esm',
    entities: 'https://cdn.jsdelivr.net/npm/entities@4.5.0/lib/esm/index.js',
    'entities/': 'https://cdn.jsdelivr.net/npm/entities@4.5.0/lib/esm/',
    'uc.micro': 'https://cdn.jsdelivr.net/npm/uc.micro@2.1.0/index.mjs',
    'punycode.js':
      'https://cdn.jsdelivr.net/npm/punycode.js@2.3.1/punycode.es6.js',
    mdurl: 'https://cdn.jsdelivr.net/npm/mdurl@2.0.0/index.mjs',
    'linkify-it': 'https://cdn.jsdelivr.net/npm/linkify-it@5.0.0/index.mjs',
    'markdown-it': 'https://cdn.jsdelivr.net/npm/markdown-it@14.1.0/index.mjs',
    'date-fns': 'https://cdn.jsdelivr.net/npm/date-fns@4.1.0/index.js',
    'date-fns/': 'https://cdn.jsdelivr.net/npm/date-fns@4.1.0/',
    'intl-tel-input/utils':
      'https://cdn.jsdelivr.net/npm/intl-tel-input@25.13.1/build/js/utils.js',
    uuid: 'https://cdn.jsdelivr.net/npm/uuid@9.0.1/dist/esm-browser/index.js',
    'http-request-mock':
      'https://cdn.jsdelivr.net/npm/http-request-mock@1.8.18/http-request-mock.esm.mjs',
    'toastify-js':
      'https://cdn.jsdelivr.net/npm/toastify-js@1.12.0/src/toastify-es.js',
    validator: 'https://cdn.jsdelivr.net/npm/validator@13.11.0/+esm',
    'libphonenumber-js':
      'https://cdn.jsdelivr.net/npm/libphonenumber-js@1.10.59/min/index.js',
    '@floating-ui/dom':
      'https://cdn.jsdelivr.net/npm/@floating-ui/dom@1.6.10/dist/floating-ui.dom.browser.min.mjs',
    '@floating-ui/core':
      'https://cdn.jsdelivr.net/npm/@floating-ui/core@1.6.7/dist/floating-ui.core.browser.min.mjs',
    '@lit/react': 'https://cdn.jsdelivr.net/npm/@lit/react@1.0.5/index.js',
    '@lit-app/state':
      'https://cdn.jsdelivr.net/npm/@lit-app/state@1.0.0/src/index.js',
    '@lit-labs/motion':
      'https://cdn.jsdelivr.net/npm/@lit-labs/motion@1.0.7/index.js',
    lit: 'https://cdn.jsdelivr.net/npm/lit@3.1.2/index.js',
    'lit/': 'https://cdn.jsdelivr.net/npm/lit@3.1.2/',
    'lit-html/': 'https://cdn.jsdelivr.net/npm/lit-html@3.1.2/',
    tslib: 'https://cdn.jsdelivr.net/npm/tslib@1.9.1/tslib.es6.js',
    mobx: 'https://cdn.jsdelivr.net/npm/mobx@6.12.0/dist/mobx.esm.production.min.js',
    'mobx-persist-store':
      'https://cdn.jsdelivr.net/npm/mobx-persist-store@1.1.5/lib/esm5/index.js',
    moment: 'https://cdn.jsdelivr.net/npm/moment@2.30.1/+esm',
    '@material/web/': 'https://cdn.jsdelivr.net/npm/@material/web@2.4.0/',
    '@material/web/chips/chip-set':
      'https://cdn.jsdelivr.net/npm/@material/web@2.4.0/chips/chip-set.js',
    '@vaadin/a11y-base':
      'https://cdn.jsdelivr.net/npm/@vaadin/a11y-base@24.6.2/index.js',
    '@vaadin/a11y-base/':
      'https://cdn.jsdelivr.net/npm/@vaadin/a11y-base@24.6.2/',
    '@vaadin/button':
      'https://cdn.jsdelivr.net/npm/@vaadin/button@24.6.2/src/vaadin-button.min.js',
    '@vaadin/button/': 'https://cdn.jsdelivr.net/npm/@vaadin/button@24.6.2/',
    '@vaadin/checkbox/':
      'https://cdn.jsdelivr.net/npm/@vaadin/checkbox@24.6.2/',
    '@vaadin/date-picker':
      'https://cdn.jsdelivr.net/npm/@vaadin/date-picker@24.6.2/vaadin-date-picker.js',
    '@vaadin/date-picker/':
      'https://cdn.jsdelivr.net/npm/@vaadin/date-picker@24.6.2/',
    '@vaadin/time-picker':
      'https://cdn.jsdelivr.net/npm/@vaadin/time-picker@24.6.2/src/vaadin-time-picker-combo-box.min.js',
    '@vaadin/overlay/': 'https://cdn.jsdelivr.net/npm/@vaadin/overlay@24.6.2/',
    '@vaadin/component-base/':
      'https://cdn.jsdelivr.net/npm/@vaadin/component-base@24.6.2/',
    '@vaadin/field-base/':
      'https://cdn.jsdelivr.net/npm/@vaadin/field-base@24.6.2/',
    '@vaadin/grid':
      'https://cdn.jsdelivr.net/npm/@vaadin/grid@24.6.2/vaadin-grid.js',
    '@vaadin/grid/': 'https://cdn.jsdelivr.net/npm/@vaadin/grid@24.6.2/',
    '@vaadin/icon/': 'https://cdn.jsdelivr.net/npm/@vaadin/icon@24.6.2/',
    '@vaadin/input-container/':
      'https://cdn.jsdelivr.net/npm/@vaadin/input-container@24.6.2/',
    '@vaadin/lit-renderer':
      'https://cdn.jsdelivr.net/npm/@vaadin/lit-renderer@24.6.2/src/lit-renderer.js',
    '@vaadin/router':
      'https://cdn.jsdelivr.net/npm/@vaadin/router@1.7.5/dist/vaadin-router.min.js',
    '@vaadin/text-field/':
      'https://cdn.jsdelivr.net/npm/@vaadin/text-field@24.6.2/',
    '@vaadin/vaadin-development-mode-detector/':
      'https://cdn.jsdelivr.net/npm/@vaadin/vaadin-development-mode-detector@2.0.6/',
    '@vaadin/vaadin-lumo-styles/':
      'https://cdn.jsdelivr.net/npm/@vaadin/vaadin-lumo-styles@24.6.2/',
    '@vaadin/vaadin-material-styles/':
      'https://cdn.jsdelivr.net/npm/@vaadin/vaadin-material-styles@24.6.2/',
    '@vaadin/vaadin-themable-mixin/':
      'https://cdn.jsdelivr.net/npm/@vaadin/vaadin-themable-mixin@24.6.2/',
    '@vaadin/vaadin-usage-statistics/':
      'https://cdn.jsdelivr.net/npm/@vaadin/vaadin-usage-statistics@2.1.2/',
    '@adobe/lit-mobx':
      'https://cdn.jsdelivr.net/npm/@adobe/lit-mobx@2.2.2/lit-mobx.js',
    '@polymer/polymer':
      'https://cdn.jsdelivr.net/npm/@polymer/polymer@3.5.2/polymer-element.js',
    '@polymer/polymer/': 'https://cdn.jsdelivr.net/npm/@polymer/polymer@3.5.2/',
    '@polymer/lib/': 'https://cdn.jsdelivr.net/npm/@polymer/polymer@3.5.2/lib/',
    '@polymer/utils/':
      'https://cdn.jsdelivr.net/npm/@polymer/polymer@3.5.2/lib/utils/',
    '@polymer/mixins/':
      'https://cdn.jsdelivr.net/npm/@polymer/polymer@3.5.2/lib/mixins/',
    '@digital-realty/ix-tooltip/':
      '{{NPM_CDN}}/@digital-realty/ix-tooltip||@1.0.3||/dist/src/',
    '@digital-realty/ix-accordion/':
      '{{NPM_CDN}}/@digital-realty/ix-accordion||@1.0.8||/dist/src/',
    '@digital-realty/theme':
      '{{NPM_CDN}}/@digital-realty/theme||@2.0.0||/dist/index.js',
    '@digital-realty/ix-widget':
      '{{NPM_CDN}}/@digital-realty/ix-widget||@2.0.0||/dist/index.js',
    '@digital-realty/ix-widget/':
      '{{NPM_CDN}}/@digital-realty/ix-widget||@2.0.0||/dist/',
    '@digital-realty/ix-account-switcher':
      '{{NPM_CDN}}/@digital-realty/ix-account-switcher||@1.0.1||/dist/index.js',
    '@digital-realty/ix-account-switcher/':
      '{{NPM_CDN}}/@digital-realty/ix-account-switcher||@1.0.1||/',
    '@digital-realty/ix-account-switcher/ix-account-switcher.js':
      '{{NPM_CDN}}/@digital-realty/ix-account-switcher||@1.0.1||/dist/ix-account-switcher.js',
    '@digital-realty/ix-filter-select/':
      '{{NPM_CDN}}/@digital-realty/ix-filter-select||@1.0.25||/dist/',
    '@digital-realty/ix-button':
      '{{NPM_CDN}}/@digital-realty/ix-button||@3.2.14||/dist/index.js',
    '@digital-realty/ix-button/':
      '{{NPM_CDN}}/@digital-realty/ix-button||@3.2.14||/dist/',
    '@digital-realty/ix-button/ix-button.js':
      '{{NPM_CDN}}/@digital-realty/ix-button||@3.2.14||/dist/ix-button.js',
    '@digital-realty/ix-card':
      '{{NPM_CDN}}/@digital-realty/ix-card||@1.0.0||/dist/src/index.js',
    '@digital-realty/ix-card/':
      '{{NPM_CDN}}/@digital-realty/ix-card||@1.0.0||/dist/src/',
    '@digital-realty/ix-checkbox/':
      '{{NPM_CDN}}/@digital-realty/ix-checkbox||@1.1.8||/dist/',
    '@digital-realty/ix-chip/':
      '{{NPM_CDN}}/@digital-realty/ix-chip||@1.0.7||/dist/',
    '@digital-realty/ix-date/':
      '{{NPM_CDN}}/@digital-realty/ix-date||@1.0.6||/dist/',
    '@digital-realty/ix-date-next/':
      '{{NPM_CDN}}/@digital-realty/ix-date-next||@1.0.0||/dist/',
    '@digital-realty/ix-dialog/':
      '{{NPM_CDN}}/@digital-realty/ix-dialog||@1.0.9||/dist/',
    '@digital-realty/ix-divider/':
      '{{NPM_CDN}}/@digital-realty/ix-divider||@1.0.7||/dist/',
    '@digital-realty/ix-drawer/':
      '{{NPM_CDN}}/@digital-realty/ix-drawer||@1.0.7||/dist/',
    '@digital-realty/ix-dropdown-tree':
      '{{NPM_CDN}}/@digital-realty/ix-dropdown-tree||@1.0.0||/dist/index.js',
    '@digital-realty/ix-dropdown-tree/':
      '{{NPM_CDN}}/@digital-realty/ix-dropdown-tree||@1.0.0||/dist/',
    '@digital-realty/ix-email-list/':
      '{{NPM_CDN}}/@digital-realty/ix-email-list||@1.0.9||/dist/',
    '@digital-realty/ix-fab/':
      '{{NPM_CDN}}/@digital-realty/ix-fab||@1.0.7||/dist/',
    '@digital-realty/ix-field/':
      '{{NPM_CDN}}/@digital-realty/ix-field||@1.0.3||/dist/',
    '@digital-realty/ix-file-uploader/':
      '{{NPM_CDN}}/@digital-realty/ix-file-uploader||@1.0.9||/dist/',
    '@digital-realty/ix-generic-tree':
      '{{NPM_CDN}}/@digital-realty/ix-generic-tree||@2.0.2||/dist/index.js',
    '@digital-realty/ix-generic-tree/':
      '{{NPM_CDN}}/@digital-realty/ix-generic-tree||@2.0.2||/dist/',
    '@digital-realty/ix-grid/':
      '{{NPM_CDN}}/@digital-realty/ix-grid||@1.0.6||/dist/',
    '@digital-realty/grid':
      '{{NPM_CDN}}/@digital-realty/grid||@1.0.0||/vaadin-grid.js',
    '@digital-realty/grid/': '{{NPM_CDN}}/@digital-realty/grid||@1.0.0||/',
    '@digital-realty/ix-icon':
      '{{NPM_CDN}}/@digital-realty/ix-icon||@1.0.2||/dist/index.js',
    '@digital-realty/ix-icon/':
      '{{NPM_CDN}}/@digital-realty/ix-icon||@1.0.2||/dist/',
    '@digital-realty/ix-icon-button/':
      '{{NPM_CDN}}/@digital-realty/ix-icon-button||@1.0.20||/dist/',
    '@digital-realty/ix-label-tag/':
      '{{NPM_CDN}}/@digital-realty/ix-label-tag||@2.1.6||/dist/',
    '@digital-realty/ix-list/':
      '{{NPM_CDN}}/@digital-realty/ix-list||@1.0.5||/dist/',
    '@digital-realty/ix-menu/':
      '{{NPM_CDN}}/@digital-realty/ix-menu||@1.0.2||/dist/',
    '@digital-realty/ix-message/':
      '{{NPM_CDN}}/@digital-realty/ix-message||@2.1.5||/dist/',
    '@digital-realty/ix-multi-select/':
      '{{NPM_CDN}}/@digital-realty/ix-multi-select||@1.0.6||/dist/',
    '@digital-realty/ix-phone-input/':
      '{{NPM_CDN}}/@digital-realty/ix-phone-input||@2.1.16||/dist/',
    '@digital-realty/ix-phone-input/ix-phone-input.js':
      '{{NPM_CDN}}/@digital-realty/ix-phone-input||@2.1.16||/esmDist/ix-phone-input.js',
    '@digital-realty/ix-phone-number/':
      '{{NPM_CDN}}/@digital-realty/ix-phone-number||@1.0.0||/dist/src/',
    '@digital-realty/ix-phone-number/ix-phone-number.js':
      '{{NPM_CDN}}/@digital-realty/ix-phone-number||@1.0.0||/dist/src/ix-phone-number.js',
    '@digital-realty/ix-pricing/':
      '{{NPM_CDN}}/@digital-realty/ix-pricing||@2.1.5||/dist/',
    '@digital-realty/ix-progress/':
      '{{NPM_CDN}}/@digital-realty/ix-progress||@1.1.8||/dist/',
    '@digital-realty/ix-radio/':
      '{{NPM_CDN}}/@digital-realty/ix-radio||@1.0.12||/dist/',
    '@digital-realty/ix-search-bar/':
      '{{NPM_CDN}}/@digital-realty/ix-search-bar||@2.1.15||/dist/',
    '@digital-realty/ix-select/ix-select-option.js':
      '{{NPM_CDN}}/@digital-realty/ix-select||@1.0.20||/dist/selectoption/ix-select-option.js',
    '@digital-realty/ix-select/':
      '{{NPM_CDN}}/@digital-realty/ix-select||@1.0.20||/dist/',
    '@digital-realty/ix-shared-fns/':
      '{{NPM_CDN}}/@digital-realty/ix-shared-fns||@1.0.1||/dist/src/',
    '@digital-realty/ix-slider/':
      '{{NPM_CDN}}/@digital-realty/ix-slider||@1.0.8||/dist/',
    '@digital-realty/ix-switch/':
      '{{NPM_CDN}}/@digital-realty/ix-switch||@2.1.8||/dist/',
    '@digital-realty/ix-switch-bar/':
      '{{NPM_CDN}}/@digital-realty/ix-switch-bar||@2.1.9||/dist/',
    '@digital-realty/ix-switch-input/':
      '{{NPM_CDN}}/@digital-realty/ix-switch-input||@2.1.18||/dist/',
    '@digital-realty/ix-tabs/':
      '{{NPM_CDN}}/@digital-realty/ix-tabs||@1.0.5||/dist/',
    '@digital-realty/ix-textbox/':
      '{{NPM_CDN}}/@digital-realty/ix-textbox||@2.1.15||/dist/',
    '@digital-realty/ix-tile-picker/':
      '{{NPM_CDN}}/@digital-realty/ix-tile-picker||@2.1.15||/dist/',
    '@digital-realty/ix-time/':
      '{{NPM_CDN}}/@digital-realty/ix-time||@1.0.6||/dist/',
    '@digital-realty/ix-timer/':
      '{{NPM_CDN}}/@digital-realty/ix-timer||@3.2.16||/dist/',
    '@digital-realty/ix-toast/':
      '{{NPM_CDN}}/@digital-realty/ix-toast||@1.0.5||/dist/src/',
    '@digital-realty/ix-tree/':
      '{{NPM_CDN}}/@digital-realty/ix-tree||@3.0.9||/dist/',
    '@digital-realty/ix-wizard/':
      '{{NPM_CDN}}/@digital-realty/ix-wizard||@1.0.8||/dist/',
    '@digital-realty/ix-intraportal-nav/':
      '{{NPM_CDN}}/@digital-realty/ix-intraportal-nav||@1.0.0||/dist/',
    '@digital-realty/ix-app-logic/':
      '{{NPM_CDN}}/@digital-realty/ix-app-logic||@1.0.0||/dist/src/',
    '@digital-realty/ix-grid/IxGridNav':
      '{{NPM_CDN}}/@digital-realty/ix-grid||@1.0.6||/dist/IxGridNav.js',
  },
  scopes: {
    'https://cdn.jsdelivr.net/npm/': {
      '@lit/reactive-element':
        'https://cdn.jsdelivr.net/npm/@lit/reactive-element@2.0.4/reactive-element.js',
      '@lit/reactive-element/':
        'https://cdn.jsdelivr.net/npm/@lit/reactive-element@2.0.4/',
      'lit-element/lit-element.js':
        'https://cdn.jsdelivr.net/npm/lit-element@4.0.4/lit-element.js',
      'lit-html': 'https://cdn.jsdelivr.net/npm/lit-html@3.1.2/lit-html.js',
      'lit-html/': 'https://cdn.jsdelivr.net/npm/lit-html@3.1.2/',
      '@material/web/chips/chip-set':
        'https://cdn.jsdelivr.net/npm/@material/web@2.4.0/chips/chip-set.js',
    },
  },
};

export const headLinks =
  '<link rel="stylesheet" href="{{NPM_CDN}}/@digital-realty/theme||@2.0.0||/dist/css/tw-reset-output.css" /><link rel="stylesheet" href="{{NPM_CDN}}/@digital-realty/theme||@2.0.0||/dist/css/baseTheme.css" />';

export const footLinks =
  '<script crossorigin="anonymous" src="https://cdn.jsdelivr.net/npm/@webcomponents/webcomponentsjs@2.8.0/webcomponents-loader.js"></script>';
